import { TripTypes } from '@model/common';
import { TourResult } from '@model/tours';
import { TourResultsGrid, TourResultsGridProps } from './TourResultsGrid';

export interface TourResultsGridContainerProps {
  tours: Array<TourResult>;
  tripType: TripTypes;
  searchToken?: string;
  isGhosting: boolean;
  isLoadingMore: boolean;
  isMoreAvailable: boolean;
  onLoadMore: () => void;
}

export const TourResultsGridContainer = ({
  tours,
  tripType,
  isGhosting,
  searchToken,
  isLoadingMore,
  isMoreAvailable,
  onLoadMore
}: TourResultsGridContainerProps) => {
  const props: TourResultsGridProps = {
    tourSearchResults: tours,
    tripType: tripType,
    isGhosting: isGhosting,
    searchToken,
    isLoadingMore,
    isMoreAvailable,
    onLoadMore
  };

  return <TourResultsGrid {...props} />;
};
